export enum EntranceRequirement {
  CONDITIONAL_GENERAL = 'CONDITIONAL_GENERAL',
  CONDITIONAL_ENGLISH = 'CONDITIONAL_ENGLISH',
  CONDITION_OTHER_TEST = 'CONDITIONAL_OTHERS',
  CONDITION_ADDITIONAL = 'CONDITIONAL_ADDITIONAL',
  CONDITIONAL_GENERAL_AND_ENGLISH = 'CONDITIONAL_GENERAL_AND_ENGLISH',
  NA = 'NA',
}

export enum OFFER_TYPE {
  FIRM = 'FIRM',
  CONDITION = 'CONDITION',
}

export enum DSRC_DECISION_TYPE {
  OFFER_APPROVED = 'OFFER_APPROVED',
  RETURN_TO_SUPERVISOR = 'RETURN_TO_SUPERVISOR',
  RETURN_TO_APPLICANT = 'RETURN_TO_APPLICANT',
  REJECT = 'REJECT',
  RETURN = 'RETURN',
}

export enum TuitionAssistantship {
  NA = 'NA',
  HALF = 'HALF',
  FULL = 'FULL',
}

export enum NOS {
  APPLICATION_NO = 'Application Number ',
  HKPFS_REF_NO = 'HKPFS Reference No.',
}

export enum PERSONAL_INFO {
  SURNAME = 'Surname of Applicant',
  FIRSTNAME = 'First Name of Applicant',
  CHINESE_NAME = 'Chinese Name',
  NATIONALITY = 'Nationality',
  IDENTITY_DOCUMENT_TYPE = 'Identity Document Type',
  IDENTITY_DOCUMENT_NUMBER = 'Identity Document Number',
  EMAIL = 'Email Address',
  MOBILE_NUMBER = 'Mobile Number',
  TELEPHONE_NUMBER = 'Telephone Number',
  ADDRESS = 'Address',
  LOCAL_INDICATOR = 'Local Indicator',
  RESIDENCE_TYPE = 'Residence Type',
  DISABILITY = 'Disability',
  DISABILITY_REMARK = 'Disability Remark',
  BIRTH = 'Birth',
  GENDER = 'Gender',
  UPDATED_AT = 'Updated At',
  CREATED_AT = 'Created At',
}

export enum PROGRAMME {
  DEPARTMENT = 'Department',
  PROGRAMME_CODE = 'Programme Code',
  STUDY_MODE = 'Study Mode',
  RESEARCH_AREA = 'Research Area',
  ENTRY_YEAR = 'Entry Year',
}

export enum PANEL_AND_SCHEME {
  PANEL = 'Panel',
  SCHEMES = 'Funding Schemes',
}

export enum SUPERVISOR_INFO {
  PROPOSED_CHIEF_SUPERVISOR = 'Name of Confirmed Chief Supervisor',
  CHIEFSUPERVISOR_MAIL = 'PolyU Email of Confirmed Chief Supervisor',
}

export enum RankingSystem {
  QS = 'QS',
  THE = 'THE',
  ARWU = 'ARWU',
}

export enum WorldUniversityRankingRange {
  TOP_1_TO_50 = 'TOP_1_TO_50',
  TOP_51_TO_100 = 'TOP_51_TO_100',
  TOP_101_TO_200 = 'TOP_101_TO_200',
  TOP_201_TO_300 = 'TOP_201_TO_300',
  TOP_301_TO_400 = 'TOP_301_TO_400',
  TOP_401_TO_500 = 'TOP_401_TO_500',
}

export enum NationalRankingSystem {
  FIRST_TIER = 'FIRST_TIER',
  SECOND_TIER = 'SECOND_TIER',
}

export enum WorldSubjectRankingRange {
  TOP_1_TO_20 = 'TOP_1_TO_20',
  TOP_21_TO_50 = 'TOP_21_TO_50',
  TOP_51_TO_75 = 'TOP_51_TO_75',
  TOP_76_TO_100 = 'TOP_76_TO_100',
  TOP_101_TO_150 = 'TOP_101_TO_150',
}

export enum DisciplineRankingSystem {
  UL1 = 'UL1',
  UL2 = 'UL2',
  UL3 = 'UL3',
  UL4 = 'UL4',
  UL5 = 'UL5',
}

export enum Ranking {
  WORLD_RANKING = 'World University Ranking',
  NATIONAL_RANKING = 'National Ranking',
  WORLD_SUBJECT_RANKING = 'World Subject Ranking',
  DISCIPLINE_SPECIFIC_LIST = 'Discipline Specific List',
  NOT_RANKED = 'This University is not ranked in the above ranking system.',
}

export enum PublicationType {
  JCR_Q1 = 'JCR_Q1',
  JCR_Q1_EQUIVALENT = 'JCR_Q1_EQUIVALENT',
  JCR_Q2 = 'JCR_Q2',
  JCR_Q2_EQUIVALENT = 'JCR_Q2_EQUIVALENT',
  NA = 'NA',
}

export enum MeritType {
  PRESTIGIOUS = 'PRESTIGIOUS',
  OTHER = 'OTHER',
  NA = 'NA',
}

export enum DepartmentInputLevel {
  VERY_STRONG = 'VERY_STRONG',
  STRONG = 'STRONG',
  MODERATE = 'MODERATE',
  WEAK = 'WEAK',
  VERY_WEAK = 'VERY_WEAK',
  NA = 'NA',
}

export enum DepartmentInputType {
  HIGH_QUALITY_RESEARCH = 'HIGH_QUALITY_RESEARCH',
  REFERENCE_LETTERS = 'REFERENCE_LETTERS',
  CHIEF_SUPERVISOR_RECORD = 'CHIEF_SUPERVISOR_RECORD',
  DEPARTMENTAL_IMPACT = 'DEPARTMENTAL_IMPACT',
}
